import { useMutation } from "@tanstack/react-query";

import { resumeAll } from "../api/ventura/contract";
import { useConfig } from "./useConfig";

function useResumeAllContracts(contractId) {
  const {
    apiHost
  } = useConfig();

  const mutation = useMutation({
    mutationKey: ['resumeAllContracts', contractId],
    mutationFn: () => resumeAll(apiHost, contractId),
  })

  return mutation;
}

export default useResumeAllContracts;
